import { render, staticRenderFns } from "./Distribution.vue?vue&type=template&id=fc2a6786"
import script from "./Distribution.vue?vue&type=script&lang=js"
export * from "./Distribution.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports